import AppConfig from '../../../lib/AppConfig';
import { cleanApiError, handleResponse } from '../../../utils/handleResponse';
import { getAPIHeaders } from '../../../utils/helpers';
import { Office } from '../types/response/Office';

export namespace OfficeRepository {
	// listOffices
	export async function listOffices(): Promise<Office[]> {
		try {
			const url = `${AppConfig.api_url}/fineract-provider/api/v1/offices`;

			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});

			const data = await handleResponse(response);

			return data;
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}
}
